import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import {
  matchDepth,
  matchDimensions,
  matchHeight,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';
import replaceFrame from 'rangeConfig/jonaxel/behaviors/replaceFrame';
import { getProductCardIconWithTooltip } from '../../utils/productCardUtils';
import { selectedEntityIsBigShelvingUnit } from 'rangeConfig/jonaxel/rules/hideMenuRules';

const frames = {
  id: 'frame-selected-menu',
  title: 'storageone.filterOptionFrames',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [replaceFrame],
    productDropped: [replaceFrame]
  },
  productTypes: [ProductType.JONAXEL_FRAME_SHELF, ProductType.JONAXEL_FRAME],
  productFilters: [matchWidth, matchHeight, matchDepth],
  productCardIcon: getProductCardIconWithTooltip,
  hidden: selectedEntityIsBigShelvingUnit
};

const size = {
  id: 'display-size',
  title: 'storageone.sizeFilterLabel',
  component: DimensionsLabel
};

const productCardWidget = {
  id: 'frames-selected-menu-frames',
  behaviors: {},
  noThumbs: () => true,
  productFilters: [matchDimensions],
  hidden: (coreApi: CoreApi) => !selectedEntityIsBigShelvingUnit(coreApi)
};

const widgets = {
  desktop: [size, frames, productCardWidget],
  mobile: [size, frames]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseShelvingUnit',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform]
};

export default selectedMenu;
